import { MenuInterface } from '../../../entities';

export const HeaderMenus: { globalMenu: MenuInterface[]; primary: MenuInterface[]; secondary: MenuInterface[] } = {
  globalMenu: [],
  primary: [
    {
      href: 'https://es.benzinga.com/news/spain/',
      label: 'Noticias de España',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://es.benzinga.com/news/spain/stocks/', label: 'Acciones', title: 'Acciones' },
          { href: 'https://es.benzinga.com/news/spain/indices/', label: 'Índices', title: 'Índices' },
          { href: 'https://es.benzinga.com/news/spain/bonds/', label: 'Bonos', title: 'Bonos' },
          { href: 'https://es.benzinga.com/news/korea/etfs/', label: 'ETFs', title: 'ETFs' },
          { href: 'https://es.benzinga.com/news/korea/economy/', label: 'Economía', title: 'Economía' },
          { href: 'https://es.benzinga.com/news/korea/general/', label: 'General', title: 'General' },
        ],
      },
      title: 'Noticias de España',
      width: '57px',
    },
    {
      href: 'https://es.benzinga.com/news/usa/',
      label: 'Noticias de EE.UU.',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://es.benzinga.com/news/usa/stocks/',
            label: 'Acciones',
            title: 'Acciones',
          },
          {
            href: 'https://es.benzinga.com/news/usa/indices/',
            label: 'Índices',
            title: 'Índices',
          },
          {
            href: 'https://es.benzinga.com/news/usa/earnings/',
            label: 'Ganancias',
            title: 'Ganancias',
          },
          {
            href: 'https://es.benzinga.com/news/usa/economy/',
            label: 'Economía',
            title: 'Economía',
          },
          {
            href: 'https://es.benzinga.com/news/usa/othermarkets/',
            label: 'Otros mercados',
            title: 'Otros mercados',
          },
          {
            href: 'https://es.benzinga.com/news/usa/analystratings/',
            label: 'Calificaciones de analistas',
            title: 'Calificaciones de analistas',
          },
          {
            href: 'https://es.benzinga.com/news/usa/trading/',
            label: 'Trading',
            title: 'Trading',
          },
          {
            href: 'https://es.benzinga.com/news/usa/pressreleases/',
            label: 'Comunicados de prensa',
            title: 'Comunicados de prensa',
          },
        ],
      },
      width: '75px',
    },
    {
      href: 'https://es.benzinga.com/news/global/',
      label: 'Noticias Mundiales',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://es.benzinga.com/news/global/europe/',
            label: 'Europa',
            title: 'Europa',
          },
          {
            href: 'https://es.benzinga.com/news/global/asia/',
            label: 'Asia',
            title: 'Asia',
          },
          {
            href: 'https://es.benzinga.com/news/global/latin-america/',
            label: 'Latinoamérica',
            title: 'Latinoamérica',
          },
        ],
      },
      title: 'Noticias Mundiales',
      width: '57px',
    },
    {
      href: 'https://es.benzinga.com/crypto/',
      label: 'Criptomonedas',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://es.benzinga.com/crypto/news/',
            label: 'Noticias',
            title: 'Noticias',
          },
          {
            href: 'https://es.benzinga.com/crypto/altcoins/',
            label: 'Altcoins',
            title: 'Altcoins',
          },
          {
            href: 'https://es.benzinga.com/crypto/bitcoin/',
            label: 'Bitcoin',
            title: 'Bitcoin',
          },
          {
            href: 'https://es.benzinga.com/crypto/blockchain/',
            label: 'Blockchain',
            title: 'Blockchain',
          },
          {
            href: 'https://es.benzinga.com/crypto/dogecoin/',
            label: 'Dogecoin',
            title: 'Dogecoin',
          },
          {
            href: 'https://it.benzinga.com/crypto/ethereum/',
            label: 'Ethereum',
            title: 'Ethereum',
          },
          {
            href: 'https://it.benzinga.com/crypto/shibainu/',
            label: 'Shiba Inu',
            title: 'Shiba Inu',
          },

          {
            href: 'https://it.benzinga.com/crypto/nfts/',
            label: 'NFT',
            title: 'NFT',
          },
        ],
      },
      title: 'Criptomonedas',
      width: '57px',
    },
    {
      href: 'https://es.benzinga.com/education/',
      label: 'Formación',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://es.benzinga.com/education/crypto/',
            label: 'Invertir en criptomonedas',
            title: 'Invertir en criptomonedas',
          },
          {
            href: 'https://es.benzinga.com/education/stocks/',
            label: 'Invertir en acciones',
            title: 'Invertir en acciones',
          },
          {
            href: 'https://es.benzinga.com/education/forex/',
            label: 'Forex',
            title: 'Forex',
          },
        ],
      },
      title: 'Formación',
      width: '57px',
    },
  ],
  secondary: [],
};
